export function numberFormat(number, decimals = 2, simbol = "$") {
    const tmp = Number(number);
    if(number === null || isNaN(tmp)) return null;
    return `${simbol} ${(tmp).toFixed(decimals).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
}